module.exports = __webpack_public_path__ + "static/img/no_data.4e58875.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/previewV2/images/no_data.png
// module id = /tTL
// module chunks = 1